import React  from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { Grid } from '@mui/material';
import ListHoursAvailables from '../../ResultSearch/components/ListHoursAvailables';
import InformationImagenologia from 'src/Professional/InformationImagenologia';
import ProfessionalImagenologia from 'src/Professional/ProfessionalImagenologia';
import { cardBase, cardHeader } from 'src/shared/styles/cardStyles';

import useImageProfessional from 'src/Professional/hooks/useImageProfessional';

export default function CardImagenologia({ professional }) {
    
    const { loadImageProfessional } = useImageProfessional();

    return (
        <Card sx={{ ...cardBase }}>
           <CardHeader
                style={{ ...cardHeader }}
                title={
                    <div
                      style={{ fontSize: 12, display: "flex", justifyContent: "space-between" }}
                    >
                      {" "}
                      <div>
                        <strong>Particular: </strong>{" "}
                        {professional.valorParticular?.replace(",", ".") || "no disponible"}
                      </div>
                      {process.env.REACT_APP_SEDE == "Calama" ? (
                        <></>
                      ) : (
                        <div>
                          <small>Sucursal: </small>
                          <strong style={{ textShadow: "1px 1px 1px #666666" }}>
                            {professional.sede}
                          </strong>
                        </div>
                      )}
                    </div>
                }
            />            
            <CardContent style={{ backgroundColor: '#F9FAFB' }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                    <ProfessionalImagenologia image={loadImageProfessional(professional.ptdRut)} alt={professional.ptdNombre} rut={professional.ptdRut} />
                    <Grid item style={{ marginLeft: 12, }}>
                        <InformationImagenologia professional={professional} />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions style={{ padding: "8px 12px" }}>
                <ListHoursAvailables professional={professional} hours={professional?.horas} />
            </CardActions>
        </Card>
    );
}